import clsx from 'clsx';
import React from 'react';
import Tag from '../../atoms/Tag/Tag';
import type { TagsListProps } from './types';

/**
 * TagsList — v2 molecule.
 *
 * Lista accesible de etiquetas ({@link Tag}). Renderiza un `<ul>` con un `<li>`
 * por etiqueta. Cuando `groupTags` es `true`, solo muestra las primeras
 * `numberOfTagsToDisplay` y añade una burbuja `+N` (clicable vía
 * `onGroupedTagsClick`) con el número de etiquetas ocultas.
 */
function TagsList({
  className,
  classTooltip,
  groupTags = false,
  numberOfTagsToDisplay = 6,
  onGroupedTagsClick = () => {},
  sizeTag,
  tags = [],
}: TagsListProps): JSX.Element {
  const visibleTags = groupTags ? tags.slice(0, numberOfTagsToDisplay) : tags;
  const hiddenCount = tags.length - numberOfTagsToDisplay;
  const shouldShowGroupedBubble = groupTags && hiddenCount > 0;

  return (
    <ul className={clsx('tags-list', className)}>
      {visibleTags.map((tag, index) => {
        const { text, guid, id, ...rest } = tag;
        return (
          <li className="tags-list__item" key={guid ?? id ?? index}>
            <Tag {...rest} label={text} size={sizeTag} tooltipClassName={classTooltip} />
          </li>
        );
      })}
      {shouldShowGroupedBubble && (
        <li className="tags-list__item">
          <Tag label={`+${hiddenCount}`} onClick={onGroupedTagsClick} size={sizeTag} tooltipClassName={classTooltip} />
        </li>
      )}
    </ul>
  );
}

export default TagsList;
